import { OrderTimelineDto, OrderTimelineLogEntryDto } from '../types/orderTimeline';
import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class OrderTimelineService {

  /**
   * Get complete order timeline with picking history, stock transactions,
   * reservations, log entries, chronological events, and detected problems.
   * Requires Lagersjef (OperatorGroupID = 2) or Administrator (OperatorGroupID = 3).
   * @param orderNo Order number
   * @returns Complete order timeline DTO
   */
  async getOrderTimeline(orderNo: number): Promise<OrderTimelineDto> {
    const url = `${API_BASE_URL}/orders/${orderNo}/timeline`;
    const response = await AuthService.authenticatedGet(url);

    if (!response.ok) {
      if (response.status === 403) {
        throw new Error('Kun lagersjefer og administratorer har tilgang til ordretidslinje');
      }
      if (response.status === 404) {
        throw new Error(`Ordre ${orderNo} ble ikke funnet`);
      }
      throw new Error(`Kunne ikke hente ordretidslinje: ${response.statusText}`);
    }

    return response.json();
  }

  /**
   * Get application log entries for an order timeline (loaded on-demand).
   * Separated from main timeline to avoid slow queries on large tenants.
   */
  async getOrderTimelineLogs(orderNo: number): Promise<OrderTimelineLogEntryDto[]> {
    const url = `${API_BASE_URL}/orders/${orderNo}/timeline/logs`;
    const response = await AuthService.authenticatedGet(url);

    if (!response.ok) {
      throw new Error(`Kunne ikke hente loggdata: ${response.statusText}`);
    }

    return response.json();
  }
}

export default new OrderTimelineService();
